import { memo } from "react";

export const OrderDetailSection = memo(function OrderDetailSection({
  orderId,
  orderDate,
}: {
  orderId: string;
  orderDate: string;
}) {
  return (
    <div style={{ marginTop: "16px", lineHeight: "1.5" }}>
      <div>
        <strong>Order number: </strong>
        {orderId}
      </div>
      <div>
        <strong>Order date: </strong>
        {orderDate}
      </div>
    </div>
  );
});
